import React from "react";
import { DA_Title } from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { usePage } from "@danishagro/shared/src/contexts/page.context";

const V1 = () => {
    const { currentPathDetails } = usePage();

    // Get the name of the last item in the currentPathDetails array
    const categoryName = currentPathDetails.at(-1)?.name ?? "";

    return (
        <DA_Container>
            <DA_Title fullWidth h1>
                {categoryName}
            </DA_Title>
        </DA_Container>
    );
};

export default V1;
